<template>
    <transition name="fade">
        <div class="modal is-active" v-show="visible">
            <div class="modal-background" @click="destroy"></div>

            <g-form :action="`/api/user/password`"
                    :form="form"
                    :loading="isLoading"
                    @loading-state="(state) => isLoading = state"
                    @success="onSuccess"
                    :message="$t('notice.saved')"
            >
                <div class="modal-content">
                    <div class="popup-dialog">
                        <div class="popup-title">
                            <h1 class="title is-1">{{ $t('account.password_change.title') }}</h1>

                            <div class="popup-close" @click.prevent="destroy">
                                <i class="icon">close</i>
                            </div>
                        </div>

                        <div class="popup-body popup-rows">
                            <div class="columns">
                                <div class="column is-one-third">
                                    <label>{{ $t('account.password_change.password_current') }}</label></div>
                                <div class="column">
                                    <g-input name="password_current" type="password" autocomplete="current-password"
                                             :label="$t('account.password_change.password_current_label')"/>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-one-third"><label>{{
                                        $t('account.password_change.password_new')
                                    }}</label></div>
                                <div class="column">
                                    <g-input name="password_new" type="password" autocomplete="new-password"
                                             :label="$t('account.password_change.password_new_label')"/>
                                    <ul class="hints">
                                        <li :class="{'success': minimumPasswordLength}">
                                            {{ $tc('account.password_change.hint.at_least_n_chars', 8) }}
                                        </li>
                                        <li :class="{'success': passwordMixedCase}">
                                            {{ $t('account.password_change.hint.mixed_case') }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="popup-footer">
                            <a @click.prevent="destroy" href="#" role="button">{{ $t('submit_dialog.cancel') }}</a>
                            <g-button :loading="isLoading">{{ $t('submit_dialog.submit') }}</g-button>
                        </div>
                    </div>
                </div>
            </g-form>
        </div>
    </transition>
</template>

<script lang="ts">
import Form from "../../../../utils/Form";

export default {
    data() {
        return {
            isLoading: false,
            form: new Form({
                password_current: '',
                password_new: ''
            })
        }
    },
    methods: {
        onSuccess() {
            this.destroy()
        }
    },
    computed: {
        minimumPasswordLength() {
            return this.form.password_new.length >= 8
        },
        passwordMixedCase() {
            const password = this.form.password_new;
            return /[a-z]/.test(password) && /[A-Z]/.test(password);
        }
    }
}
</script>

<style lang="scss" scoped>
ul.hints {
    font-size: 0.9375rem;
    list-style-type: none;
    margin: -0.1rem 0 0.1rem 0;
    padding: 0;

    li {
        color: #6A7272;

        &.success {
            color: #3BC173;

            &:before {
                content: 'check';
            }
        }

        &:before {
            font-family: 'Material Symbols Outlined';
            font-weight: normal;
            font-style: normal;
            font-size: 18px;
            line-height: 1;
            vertical-align: sub;
            letter-spacing: normal;
            text-transform: none;
            display: inline-block;
            white-space: nowrap;
            word-wrap: normal;
            direction: ltr;
            content: 'close';
        }
    }
}
</style>
